import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";

const SKELETON_ITEMS = 6;

export default function FeaturedSuppliers() {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    const fetchFeaturedSuppliers = async () => {
      try {
        setLoading(true);

        const response = await api.get("/accounts/suppliers/featured/");

        if (!isMounted) return;

        setSuppliers(Array.isArray(response.data) ? response.data : []);
        setError(null);
      } catch (err) {
        if (!isMounted) return;

        console.error("Error fetching suppliers:", err);
        setError("خطا در بارگذاری تأمین‌کنندگان");
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchFeaturedSuppliers();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleSupplierClick = (supplier) => {
    const supplierId = supplier.supplier_id || supplier.id;

    if (!supplierId) return;

    navigate(`/shopping/product-list/?supplier_id=${supplierId}`);
  };

  if (loading) {
    return (
      <div className="grid grid-cols-3 gap-x-2 gap-y-4 px-1 sm:grid-cols-4 sm:gap-x-4 sm:gap-y-5 lg:grid-cols-6 lg:gap-x-6 lg:gap-y-6">
        {Array.from({ length: SKELETON_ITEMS }).map((_, index) => (
          <div
            key={index}
            className="flex min-w-0 flex-col items-center gap-2"
          >
            <div className="h-16 w-16 animate-pulse rounded-full bg-gray-200 sm:h-20 sm:w-20" />

            <div className="h-3 w-16 animate-pulse rounded bg-gray-200 sm:w-20" />
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-xl border border-gray-200 bg-gray-50 px-3 py-5 text-center text-xs text-gray-500 sm:rounded-2xl sm:py-7 sm:text-sm">
        {error}
      </div>
    );
  }

  if (!suppliers.length) {
    return null;
  }

  return (
    <div className="grid grid-cols-3 gap-x-2 gap-y-4 px-1 sm:grid-cols-4 sm:gap-x-4 sm:gap-y-5 lg:grid-cols-6 lg:gap-x-6 lg:gap-y-6">
      {suppliers.map((supplier) => (
        <button
          key={supplier.id || supplier.supplier_id}
          type="button"
          onClick={() => handleSupplierClick(supplier)}
          className="group flex min-w-0 flex-col items-center gap-1.5 rounded-xl p-1.5 text-center transition-colors duration-200 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFC107] focus-visible:ring-offset-2 sm:gap-2 sm:p-2"
        >
          {/* لوگو */}
          <span className="relative block h-16 w-16 overflow-hidden rounded-full border-2 border-gray-200 bg-white p-1 shadow-sm transition-all duration-200 group-hover:border-[#FFC107] group-hover:shadow-md sm:h-20 sm:w-20">
            <img
              src={supplier.logo || "/assets/images/default-supplier.png"}
              alt={supplier.full_name || "تأمین‌کننده"}
              className="h-full w-full rounded-full object-cover"
              loading="lazy"
            />
          </span>

          {/* نام تأمین‌کننده */}
          <span className="block w-full truncate px-0.5 text-[11px] font-medium leading-5 text-gray-700 transition-colors duration-200 group-hover:text-[#1E3A5F] sm:text-sm">
            {supplier.full_name}
          </span>
        </button>
      ))}
    </div>
  );
}
